const initialState = {
  cpaGroupFetching: false,
  cpaGroup: [],
  cpaGroupError: null,

  cpaGroupSyncFetching: false,
  cpaGroupSync: null,
  cpaGroupSyncError: null,

  cpaGroupMappingFetching: false,
  cpaGroupMapping: [],
  cpaGroupMappingError: null,

  cpaGroupMappingSyncFetching: false,
  cpaGroupMappingSync: null,
  cpaGroupMappingSyncError: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "CPA_GROUP_GET_PENDING":
      return { ...state, cpaGroupFetching: true, cpaGroupError: null };
    case "CPA_GROUP_GET_FULFILLED":
      return { ...state, cpaGroupFetching: false, cpaGroup: action.payload };
    case "CPA_GROUP_GET_REJECTED":
      return { ...state, cpaGroupFetching: false, cpaGroupError: action.payload };

    case "CPA_GROUP_SYNC_PENDING":
      return { ...state, cpaGroupSyncFetching: true, cpaGroupSyncError: null };
    case "CPA_GROUP_SYNC_FULFILLED":
      return { ...state, cpaGroupSyncFetching: false, cpaGroupSync: action.payload };
    case "CPA_GROUP_SYNC_REJECTED":
      return { ...state, cpaGroupSyncFetching: false, cpaGroupSyncError: action.payload };

    case "CPA_GROUP_MAPPING_GET_PENDING":
      return { ...state, cpaGroupMappingFetching: true, cpaGroupMappingError: null };
    case "CPA_GROUP_MAPPING_GET_FULFILLED":
      return { ...state, cpaGroupMappingFetching: false, cpaGroupMapping: action.payload };
    case "CPA_GROUP_MAPPING_GET_REJECTED":
      return { ...state, cpaGroupMappingFetching: false, cpaGroupMappingError: action.payload };

    case "CPA_GROUP_MAPPING_SYNC_PENDING":
      return { ...state, cpaGroupMappingSyncFetching: true, cpaGroupMappingSyncError: null };
    case "CPA_GROUP_MAPPING_SYNC_FULFILLED":
      return { ...state, cpaGroupMappingSyncFetching: false, cpaGroupMappingSync: action.payload };
    case "CPA_GROUP_MAPPING_SYNC_REJECTED":
      return { ...state, cpaGroupMappingSyncFetching: false, cpaGroupMappingSyncError: action.payload };

    default:
      return state;
  }
}
